import "./App.scss";
import { useEffect } from "react";
import mojs from "@mojs/core";

const Billboard = () => {
  useEffect(() => {
    const links = document.querySelectorAll("a");
    links.forEach((link) => link.addEventListener("mouseenter", shootLines));

    function shootLines(e) {
      const itemDim = this.getBoundingClientRect(),
        itemSize = {
          x: itemDim.right - itemDim.left,
          y: itemDim.bottom - itemDim.top,
        },
        shapes = ["line", "zigzag"],
        colors = ["#2FB5F3", "#FF0A47", "#FF0AC2", "#47FF0A"];

      const chosenC = Math.floor(Math.random() * colors.length),
        chosenS = Math.floor(Math.random() * shapes.length);

      const burst = new mojs.Burst({
        left: itemDim.left + itemSize.x / 2,
        top: itemDim.top + itemSize.y / 2,
        radiusX: itemSize.x,
        radiusY: itemSize.y,
        count: 8,
        children: {
          shape: shapes[chosenS],
          radius: 10,
          scale: { 0.8: 1 },
          fill: "none",
          points: 7,
          stroke: colors[chosenC],
          strokeDasharray: "100%",
          strokeDashoffset: { "-100%": "100%" },
          duration: 350,
          delay: 100,
          easing: "quad.out",
          isShowEnd: false,
        },
      });

      burst.play();
    }
  }, []);

  return (
    <div
      style={{
        padding: 40,
        maxWidth: 800,
        margin: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <h3 className="animate" style={{ textAlign: "center" }}>
        <a href="">
          Sponsor a digital billboard watched by 1000's of creatives,
          entrepreneurs and professionals monthly.
        </a>
      </h3>
      <img style={{ width: "100%" }} src="/billboard.png" />
      <p>
        <ul>
          <li>
            + Viewed for <strong>100 hours!</strong> per day by users in full
            screen
          </li>
          <li>
            + <strong>Beautiful</strong> custom billboard in kaizenflow style
            for your brand with subtle product placement
          </li>
          <li>
            + <strong>Link to your brand</strong> and tagline on billboard
          </li>
          <li>
            + <strong>Exclusively</strong> yours (one brand at any given time)
          </li>
          <li>
            + Audience interests: productivity, motivation, self-improvement,
            self care, wellness, mental wellbeing
          </li>
        </ul>
      </p>
      <a
        style={{
          fontWeight: "bold",
          color: "black",
          padding: 14,
          backgroundColor: "white",
          border: "none",
          borderRadius: 4,
        }}
        target="_blank"
        href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&to=samuel@kudoscope.com&subject=kaizenflow+advertising&body=Hello,%0A%0AI%27d+like+to+hear+more+about+advertising+in+kaizenflow+:)+%0A%0AThanks,+%0A%0AMy+Name%0A%0A%0A%0A"
      >
        I'm interested, lets talk
      </a>
      <span style={{ marginTop: 14, color: "white", fontSize: 14 }}>
        * next available space{" "}
        {new Date().toLocaleString("en-us", { month: "short" })} 2022
      </span>
    </div>
  );
};

export default Billboard;
